/**
 * Test-id slugs must always be English. Menu labels come from the API in
 * Czech, so known labels are translated via this map; unknown labels fall
 * back to an ASCII slug (diacritics stripped) so selectors stay stable —
 * add new labels here as the API menu grows.
 */
const LABEL_SLUGS: Record<string, string> = {
  // sidebar (menu_1)
  akce: 'actions',
  data: 'data',
  sprava: 'management',
  nastaveni: 'settings',
  databaze: 'database',
  // topbar (menu_2)
  stavby: 'buildings',
  stavba: 'building',
  obecne: 'general',
  reseni: 'solutions',
  sablony: 'templates',
  vyrobky: 'products',
  'sprava-firmy': 'company-management',
  'ke-stazeni': 'downloads',
  'super-admin': 'super-admin',
  // ribbon (menu_3/menu_4)
  dokumentace: 'documentation',
  faze: 'phases',
  'vykonove-faze': 'performance-phases',
  vzhledy: 'appearances',
  dezeny: 'patterns',
  barvy: 'colors',
  'upravy-povrchu': 'surface-finishes',
  'stavebni-objekty': 'building-objects',
  'dvere-vrata': 'doors-gates',
  'sprava-akci': 'action-management',
  biblio: 'biblio',
  'polozky-zprav': 'report-items',
  'profesni-vazby': 'professional-relations',
  'sady-vlastnosti': 'property-sets',
  'sady-zprav': 'report-sets',
  vlastnosti: 'properties',
  jednotky: 'units',
  tridnik: 'classification',
  klasifikace: 'classification',
  faktury: 'invoices',
  'sprava-roli': 'role-management',
  'sprava-tymu': 'team-management',
  'zalozit-firmu': 'create-company',
  // action labels
  pridat: 'add',
  upravit: 'edit',
  odstranit: 'remove',
  smazat: 'delete',
  ulozit: 'save',
  zavrit: 'close',
  'nastaveni-tisku': 'print-settings',
};

export function navTestId(label: unknown, fallback = 'item'): string {
  const slug = (label ?? '')
    .toString()
    .replace(/<[^>]*>/g, '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-');
  if (!slug) return fallback;
  return LABEL_SLUGS[slug] ?? slug;
}
